import { EntityStatus, FormType } from "@/enums";
import { useGetProductCategoryFormsQuery } from "@/services";
import { node } from "prop-types";
import { createContext, useContext, useEffect, useState } from "react";

export const FormPropertyContext = createContext();
export const useFormPropertyProvider = () => useContext(FormPropertyContext);

export const FormPropertyProvider = ({ children }) => {
  const { data: formData } = useGetProductCategoryFormsQuery();

  const [intakeForm, setIntakeForm] = useState(null);

  useEffect(() => {
    setIntakeForm(formData?.intake);
  }, [formData]);

  const getFormProperties =
    /* This unused productCategory variable can't be removed
     * until we remove where it's being passed in
     * or else the page breaks
     */
    (formType) => {
      const filterForm = (form) =>
        form?.filter(
          ({ property: { name, status } }) =>
            status === EntityStatus.Active || name === "status"
        ) ?? [];
      formType =
        formType?.toLowerCase() === FormType.Intake.toLowerCase() &&
        FormType.Intake;

      if (formType === FormType.Intake) return filterForm(intakeForm);
    };

  const getAllValuesForProperty = (formType, propertyName) => {
    const form = getFormProperties(formType);

    if (!form) return undefined;

    return form
      .filter(
        ({ property: { name }, values }) => name === propertyName && values
      )
      .map(({ values }) => values)
      .flat();
  };

  const getProperty = (formType, propertyName) =>
    getFormProperties(formType)?.find(
      ({ property }) => property.Name === propertyName
    );

  const retrievePropertiesRecursive = (form, formProperties) => {
    form?.forEach(({ children, property }) => {
      if (children)
        formProperties.push(
          retrievePropertiesRecursive(children, formProperties)
        );
      if (property.status === EntityStatus.Active || property.name === "Status")
        formProperties.push(property);
    });
  };

  const getAllFormProperties = (formType) => {
    var formProperties = [];
    var formData = null;
    if (formType === FormType.Intake) formData = intakeForm;
    retrievePropertiesRecursive(formData, formProperties);
    return formProperties;
  };

  return (
    <FormPropertyContext.Provider
      value={{
        getProperty,
        getFormProperties,
        getAllValuesForProperty,
        getAllFormProperties,
      }}
    >
      {children}
    </FormPropertyContext.Provider>
  );
};

FormPropertyProvider.propTypes = {
  children: node.isRequired,
};
